import React, { useEffect, useState } from 'react';
import { useFetchItems } from '../../hooks/base-hooks';
import { CacheKey } from '../../types/cache-keys';

const ProductIcon = ({ svgIconId }: { svgIconId: number }) => {
  const { data: svgData, isLoading: isLoadingItems } = useFetchItems(
    'db/svg-icon',
    CacheKey.ProductIcon
  );
  const [svgSrc, setSvgSrc] = useState(null);

  useEffect(() => {
    if (!svgData) {
      return;
    }
    setSvgSrc(svgData.find((svgIcon) => svgIcon.id === svgIconId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [svgData, setSvgSrc]);

  return (
    <div className='rounded-xl bg-cisco-blue-60 p-px box-border'>
      {!!svgSrc && (
        <img
          className='h-14 w-14 invert'
          src={`data:image/svg+xml;utf8,${svgSrc.content}`}
        />
      )}
      {!svgSrc && (
        <div className='w-14 h-14 p-2'>
          <div className='rounded-full border border-white h-full w-full'></div>
        </div>
      )}
    </div>
  );
};

export default ProductIcon;
